import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import * as React from "react";

import API from "../api";
import { ZentakeContext } from "./ZentakeContext";

const withStripe = (WrappedComponent) =>
  function (props) {
    const [stripePublishableKey, setStripePublishableKey] = React.useState("");
    const [ready, setReady] = React.useState(false);

    const { stripeIntegration } = React.useContext(ZentakeContext);

    React.useEffect(() => {
      const fetchStripeData = async () => {
        const { key } = await API.getStripeConfig();
        setStripePublishableKey(key);
        setReady(true);
      };

      fetchStripeData();
    }, []);

    const stripePromise = React.useMemo(() => {
      if (stripeIntegration?.api_publishable_key) {
        return loadStripe(stripeIntegration.api_publishable_key);
      }

      if (!stripePublishableKey || !stripeIntegration?.account_id) return null;

      return loadStripe(stripePublishableKey, {
        stripeAccount: stripeIntegration?.account_id,
      });
    }, [
      stripeIntegration?.api_publishable_key,
      stripeIntegration?.account_id,
      stripePublishableKey,
    ]);

    return (
      <Elements stripe={stripePromise}>
        {ready ? <WrappedComponent {...props} /> : null}
      </Elements>
    );
  };

export default withStripe;
